import { render, staticRenderFns } from "./NewPartnerProfile.vue?vue&type=template&id=5cfee664&scoped=true"
import script from "./NewPartnerProfile.vue?vue&type=script&lang=js"
export * from "./NewPartnerProfile.vue?vue&type=script&lang=js"
import style0 from "./NewPartnerProfile.vue?vue&type=style&index=0&id=5cfee664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfee664",
  null
  
)

export default component.exports